// #3187 APPROVE.4 — the readable text of an artefact version's `notes` blob,
// for the client approval version view and its diff. The same shapes
// ArtefactDetailContent's Content panel reads: imported content `{ text }`,
// agent and UX artefacts `{ markdown, json }`, a few with `{ content }`; any
// other JSON is pretty-printed, and a non-JSON string is shown as written.

export function artefactVersionText(notes: string | null | undefined): string {
  if (!notes) return '';
  try {
    const parsed: unknown = JSON.parse(notes);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const p = parsed as Record<string, unknown>;
      for (const key of ['text', 'markdown', 'content'] as const) {
        if (typeof p[key] === 'string') return p[key] as string;
      }
    }
    if (typeof parsed === 'string') return parsed;
    return '```json\n' + JSON.stringify(parsed, null, 2) + '\n```';
  } catch {
    return notes;
  }
}
